/** Industry → letter code */
const INDUSTRY_MAP = {
    'Marketing Agency': 'A',
    'Boutique Fitness': 'BF',
    'Coach/Consultant': 'C',
    'Chiropractor': 'CH',
    'eCommerce': 'E',
    'Local Service': 'L',
    'Med Spa': 'M',
    'Professional Service': 'P',
    'Real Estate': 'R',
};
/** Revenue ranges grouped by stage (1 = Hustler, 2 = Builder, 3 = Scaler) */
const REVENUE_STAGES = {
    // Hustler (1)
    'Pre Revenue': 1,
    '$1K - $2K / month': 1,
    '$2K - $5K / month': 1,
    '$5K - $8K / month': 1,
    // Builder (2)
    '$8K - $10K / month': 2,
    '$10K - $20K / month': 2,
    '$20K - $40K / month': 2,
    '$40K - $60K / month': 2,
    '$60K - $80K / month': 2,
    // Scaler (3)
    '$80K - $100K / month': 3,
    '$100K - $200K / month': 3,
    '$200K - $500K / month': 3,
    '$500K / month +': 3,
};
/** Map legacy dashboard revenue values to canonical Typeform values */
export const LEGACY_REVENUE_MAP = {
    'Pre-Revenue': 'Pre Revenue',
    '$0 - $1K': 'Pre Revenue',
    '$1K - $5K': '$2K - $5K / month',
    '$5K - $10K': '$5K - $8K / month',
    '$10K - $25K': '$10K - $20K / month',
    '$25K - $50K': '$20K - $40K / month',
    '$50K - $75K': '$60K - $80K / month',
    '$75K - $100K': '$80K - $100K / month',
    '$100K - $150K': '$100K - $200K / month',
    '$150K - $250K': '$200K - $500K / month',
    '$250K - $350K': '$200K - $500K / month',
    '$350K - $500K': '$200K - $500K / month',
    '$500K+': '$500K / month +',
};
/**
 * Normalize a revenue string — if it's a legacy dashboard value, map it
 * to the canonical Typeform value. Otherwise return as-is.
 */
export function normalizeRevenue(raw) {
    return LEGACY_REVENUE_MAP[raw] ?? raw;
}
/**
 * Derive a FounderCategoryCode (e.g. "C2") from industry + revenue.
 * Returns null if either value is unrecognized.
 */
export function deriveFounderCategory(industry, revenue) {
    if (!industry || !revenue)
        return null;
    const letter = INDUSTRY_MAP[industry];
    if (!letter)
        return null;
    const normalized = normalizeRevenue(revenue);
    const stage = REVENUE_STAGES[normalized];
    if (!stage)
        return null;
    return `${letter}${stage}`;
}
/** Reverse map: letter code → first matching industry name */
const LETTER_TO_INDUSTRY = Object.fromEntries(Object.entries(INDUSTRY_MAP).map(([name, letter]) => [letter, name]));
/** Default revenue value per stage (first/lowest in each bracket) */
const STAGE_TO_REVENUE = {
    1: 'Pre Revenue',
    2: '$8K - $10K / month',
    3: '$80K - $100K / month',
};
/**
 * Given a FounderCategoryCode (e.g. "C2"), return default industry + revenue
 * values that would derive back to that code.
 * Returns null if code is invalid.
 */
export function defaultBriefForCategory(code) {
    const stage = parseInt(code.at(-1) ?? '', 10);
    const letter = code.slice(0, -1);
    const industry = LETTER_TO_INDUSTRY[letter];
    const revenue = STAGE_TO_REVENUE[stage];
    if (!industry || !revenue)
        return null;
    return { industry, monthlyRevenue: revenue };
}
//# sourceMappingURL=founder-category.js.map